var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "position-relative" }, [
    _vm.isLoggedIn
      ? _c("div", { staticClass: "dropdown" }, [
          _c(
            "a",
            {
              staticClass: "dropdown-toggle nav-link",
              attrs: {
                href: "#",
                id: "accountMenuList",
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false",
                "data-boundary": "window",
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "20",
                    height: "22.222",
                    viewBox: "0 0 20 22.222",
                  },
                },
                [
                  _c(
                    "g",
                    { attrs: { id: "Icon", transform: "translate(0 1.11)" } },
                    [
                      _c("rect", {
                        attrs: {
                          id: "Area",
                          width: "20",
                          height: "20",
                          transform: "translate(0 0.001)",
                          opacity: "0",
                        },
                      }),
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "Icon-2",
                            "data-name": "Icon",
                            transform: "translate(1.111 0.001)",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              id: "_28f940d6-a184-4e42-99aa-0b541e7b6ae6",
                              "data-name":
                                "28f940d6-a184-4e42-99aa-0b541e7b6ae6",
                              d: "M22.222,23.333V21.111a4.444,4.444,0,0,0-4.444-4.444H8.889a4.444,4.444,0,0,0-4.445,4.444v2.222",
                              transform: "translate(-4.444 -3.333)",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2.222",
                            },
                          }),
                          _c("circle", {
                            attrs: {
                              id: "f7c0d18f-4f02-4370-a64a-1cc586babf08",
                              cx: "4.444",
                              cy: "4.444",
                              r: "4.444",
                              transform: "translate(4.445)",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2.222",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "d-none d-sm-inline" }, [
                _vm._v(
                  _vm._s(
                    _vm.$translate("Ceres::Template.loginHello", {
                      username: _vm.username,
                    })
                  )
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown-menu small m-0 p-0 mw-100" }, [
            _c(
              "div",
              {
                staticClass: "list-group",
                attrs: { "aria-labelledby": "accountMenuList" },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "list-group-item small",
                    attrs: { href: _vm.$ceres.urls.myAccount },
                  },
                  [
                    _c("i", { staticClass: "fa fa-user" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$translate("Ceres::Template.loginMyAccount"))
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [{ name: "logout", rawName: "v-logout" }],
                    staticClass: "list-group-item small",
                    attrs: { href: "#" },
                  },
                  [
                    _c("i", { staticClass: "fa fa-sign-out" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$translate("Ceres::Template.loginLogout"))
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoggedIn && !_vm.showSimple
      ? _c("div", [
          _vm.showLogin
            ? _c(
                "a",
                {
                  staticClass: "nav-link",
                  attrs: {
                    "data-testing": "login-select",
                    href: _vm.isLogin ? "javascript:void(0)" : "#login",
                    "data-toggle": _vm.isLogin ? false : "modal",
                    "aria-label": _vm.$translate("Ceres::Template.login"),
                  },
                  on: {
                    click: function ($event) {
                      _vm.createLoginModal()
                      _vm.unmarkInputFields()
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "20",
                        height: "22.222",
                        viewBox: "0 0 20 22.222",
                      },
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: { id: "Icon", transform: "translate(0 1.11)" },
                        },
                        [
                          _c("rect", {
                            attrs: {
                              id: "Area",
                              width: "20",
                              height: "20",
                              transform: "translate(0 0.001)",
                              opacity: "0",
                            },
                          }),
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "Icon-2",
                                "data-name": "Icon",
                                transform: "translate(1.111 0.001)",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  id: "_28f940d6-a184-4e42-99aa-0b541e7b6ae6",
                                  "data-name":
                                    "28f940d6-a184-4e42-99aa-0b541e7b6ae6",
                                  d: "M22.222,23.333V21.111a4.444,4.444,0,0,0-4.444-4.444H8.889a4.444,4.444,0,0,0-4.445,4.444v2.222",
                                  transform: "translate(-4.444 -3.333)",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2.222",
                                },
                              }),
                              _c("circle", {
                                attrs: {
                                  id: "f7c0d18f-4f02-4370-a64a-1cc586babf08",
                                  cx: "4.444",
                                  cy: "4.444",
                                  r: "4.444",
                                  transform: "translate(4.445)",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2.222",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoggedIn && _vm.showSimple
      ? _c("div", [
          _vm.showLogin
            ? _c(
                "a",
                {
                  staticClass: "nav-link",
                  attrs: {
                    "data-testing": "login-select",
                    href: _vm.isLogin ? "javascript:void(0)" : "#login",
                    "data-toggle": _vm.isLogin ? false : "modal",
                    "aria-label": _vm.$translate("Ceres::Template.login"),
                  },
                  on: {
                    click: function ($event) {
                      _vm.$store.commit("setIsMobileNavigationOpen", false)
                      _vm.createLoginModal()
                      _vm.unmarkInputFields()
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "20",
                        height: "22.222",
                        viewBox: "0 0 20 22.222",
                      },
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: { id: "Icon", transform: "translate(0 1.11)" },
                        },
                        [
                          _c("rect", {
                            attrs: {
                              id: "Area",
                              width: "20",
                              height: "20",
                              transform: "translate(0 0.001)",
                              fill: "#fcfcfc",
                              opacity: "0",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "Icon-2",
                                "data-name": "Icon",
                                transform: "translate(1.111 0.001)",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  id: "_28f940d6-a184-4e42-99aa-0b541e7b6ae6",
                                  "data-name":
                                    "28f940d6-a184-4e42-99aa-0b541e7b6ae6",
                                  d: "M22.222,23.333V21.111a4.444,4.444,0,0,0-4.444-4.444H8.889a4.444,4.444,0,0,0-4.445,4.444v2.222",
                                  transform: "translate(-4.444 -3.333)",
                                  fill: "none",
                                  stroke: "#fff",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2.222",
                                },
                              }),
                              _vm._v(" "),
                              _c("circle", {
                                attrs: {
                                  id: "f7c0d18f-4f02-4370-a64a-1cc586babf08",
                                  cx: "4.444",
                                  cy: "4.444",
                                  r: "4.444",
                                  transform: "translate(4.445)",
                                  fill: "none",
                                  stroke: "#fff",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2.222",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }